import { defineMessages } from 'react-intl';

export const helpModalMessages = defineMessages({
  title: {
    id: 'dashboard.steps.title',
    defaultMessage: 'How to use the Estimator?',
  },
  learnAboutButtonLabel: {
    id: 'dashboard.steps.buttons.learnAbout',
    defaultMessage: 'Learn about {currentStep}',
  },
  showLessButtonLabel: {
    id: 'dashboard.steps.buttons.showLess',
    defaultMessage: 'Show less',
  },
  aiAdvisoryLabel: {
    id: 'dashboard.steps.guide.aiAdvisory.title',
    defaultMessage: 'AI Advisory',
  },
  aiAdvisoryShortDescription: {
    id: 'dashboard.steps.guide.aiAdvisory.description.short',
    defaultMessage:
      'Optional pre-step: start a conversation with the AI Advisor to generate an initial draft estimate from a short project description.',
  },
  aiAdvisoryLongDescription: {
    id: 'dashboard.steps.guide.aiAdvisory.description.long',
    defaultMessage:
      'Before creating a new estimation manually, you can use the AI Advisory as an optional pre-step. The AI Advisor helps you produce an initial estimate from a short project description, which you can then continue to refine in the following steps. This step is entirely optional — you can also start directly with Setup.',
  },
  setupLabel: {
    id: 'dashboard.steps.guide.basics.title',
    defaultMessage: 'Setup',
  },
  setupShortDescription: {
    id: 'dashboard.steps.guide.basics.description.short',
    defaultMessage:
      'Please enter the basics of the project here, such as the project name, type, involved persons, and the estimation method in Esti Mate.',
  },
  setupLongDescription: {
    id: 'dashboard.steps.guide.basics.description.long',
    defaultMessage:
      'In the first step, you need to enter the basic data of the project. This includes the project name, type, involved persons, and the selected estimation methodology. This information forms the basis for the further process. Ensure that these details are precise and complete.',
  },
  chooseModeLabel: {
    id: 'dashboard.steps.guide.chooseMode.title',
    defaultMessage: 'Choose Mode',
  },
  chooseModeShortDescription: {
    id: 'dashboard.steps.guide.chooseMode.description.short',
    defaultMessage:
      'After Setup, choose how to continue: Estimation Wizard Mode (guided, step-by-step) or Estimation Detailed Mode (direct full control).',
  },
  chooseModeLongDescription: {
    id: 'dashboard.steps.guide.chooseMode.description.long',
    defaultMessage:
      'After completing Setup, you decide how to continue your estimation. Choose Estimation Wizard Mode for a guided, step-by-step experience that walks you through each phase — recommended for standard flows or less experienced users. Choose Estimation Detailed Mode to jump straight into the full detailed view, for advanced users or fine-tuning. The detailed process steps that follow (Master Data, Phases, Estimate, Resource, Costs, Review) are the same and accessible via either mode.',
  },
  masterdataLabel: {
    id: 'dashboard.steps.guide.metadata.title',
    defaultMessage: 'Master Data',
  },
  masterdataShortDescription: {
    id: 'dashboard.steps.guide.metadata.description.short',
    defaultMessage:
      'Please capture the central framework conditions of your project, including objectives, scope, and rough timeline.',
  },
  masterdataLongDescription: {
    id: 'dashboard.steps.guide.metadata.description.long',
    defaultMessage:
      'In the second step, you need to enter the central framework conditions of your project. This includes the project name, type, involved persons, and the selected estimation methodology. This information forms the basis for the further process. Ensure that these details are precise and complete.',
  },
  projectPhasesLabel: {
    id: 'dashboard.steps.guide.projectPhases.title',
    defaultMessage: 'Phases',
  },
  projectPhasesShortDescription: {
    id: 'dashboard.steps.guide.projectPhases.description.short',
    defaultMessage:
      'Please divide the project into different phases and document specific planning assumptions for each phase.',
  },
  projectPhasesLongDescription: {
    id: 'dashboard.steps.guide.projectPhases.description.long',
    defaultMessage:
      'In the third step, you need to divide the project into different phases and document specific planning assumptions for each phase. This information forms the basis for the further process. Ensure that these details are precise and complete.',
  },
  estimatingLabel: {
    id: 'dashboard.steps.guide.estimating.title',
    defaultMessage: 'Estimate',
  },
  estimatingShortDescription: {
    id: 'dashboard.steps.guide.estimating.description.short',
    defaultMessage:
      'Please estimate the effort for each project phase/subphase (work package) and calculate the necessary resource usage.',
  },
  estimatingLongDescription: {
    id: 'dashboard.steps.guide.estimating.description.long',
    defaultMessage:
      'In the third step, you need to estimate the effort for each project phase/subphase (work package) and calculate the necessary resource usage. This information forms the basis for the further process. Ensure that these details are precise and complete.',
  },
  resourceLabel: {
    id: 'dashboard.steps.guide.resourcing.title',
    defaultMessage: 'Resource',
  },
  resourceShortDescription: {
    id: 'dashboard.steps.guide.resourcing.description.short',
    defaultMessage:
      'Please assign the personnel resources, divided into internal/external and specialist/IT resources, to the tasks.',
  },
  resourceLongDescription: {
    id: 'dashboard.steps.guide.resourcing.description.long',
    defaultMessage:
      'In the third step, you need to assign the personnel resources, divided into internal/external and specialist/IT resources, to the tasks. This information forms the basis for the further process. Ensure that these details are precise and complete.',
  },
  costsLabel: {
    id: 'dashboard.steps.guide.costing.title',
    defaultMessage: 'Costs',
  },
  costsShortDescription: {
    id: 'dashboard.steps.guide.costing.description.short',
    defaultMessage:
      'Please calculate the project costs using the daily rates of the resource groups and add any applicable operating expenses.',
  },
  costsLongDescription: {
    id: 'dashboard.steps.guide.costing.description.long',
    defaultMessage:
      'In the third step, you need to calculate the project costs using the daily rates of the resource groups and add any applicable operating expenses. This information forms the basis for the further process. Ensure that these details are precise and complete.',
  },
  reviewLabel: {
    id: 'dashboard.steps.guide.review.title',
    defaultMessage: 'Review',
  },
  reviewShortDescription: {
    id: 'dashboard.steps.guide.review.description.short',
    defaultMessage:
      'Here you have the option to verify your estimate through an AI-assisted validation and/or have it reviewed by another project manager through a peer review.',
  },
  reviewLongDescription: {
    id: 'dashboard.steps.guide.review.description.long',
    defaultMessage:
      'In the third step, you need to verify your estimate through an AI-assisted validation and/or have it reviewed by another project manager through a peer review. This information forms the basis for the further process. Ensure that these details are precise and complete.',
  },
});
